import {
  RequestDemoData,
  TenantRepository,
} from "../../../domain/tenant-repository";
import { Injectable } from "@angular/core";
import { HttpService } from "../../http/http";
import { Tenant } from "../../../domain/tenant";

@Injectable()
export class TenantRepositoryImpl implements TenantRepository {
  private allTenants: Array<Tenant>;

  constructor(private httpService: HttpService) {}

  public createNewTenantAndTrialUserFromTemplate(
    channelTemplateId: number,
    channelName: string,
    activateChannel: boolean,
    request: RequestDemoData,
  ): Promise<void> {
    return this.httpService
      .post("tenant/CreateNewTenantAndUserFromTemplate", {
        channelTemplateId: channelTemplateId,
        channelName: channelName,
        activateChannel: activateChannel,
        requestDemo: request,
      })
      .then((result) => {
        return result;
      });
  }

  create(name: string): Promise<Tenant> {
    return this.httpService
      .post("tenant/Create", { name: name })
      .then((createNewTenantResponse) => {
        return new Tenant(
          createNewTenantResponse.Id,
          createNewTenantResponse.Guid,
          createNewTenantResponse.Name,
        );
      });
  }

  getAll(): Promise<Array<Tenant>> {
    return new Promise((resolve, reject) => {
      if (this.allTenants) {
        resolve(this.allTenants);
      }

      return this.httpService.get("tenant/Get").then((response) => {
        resolve(
          response.map(
            (responseTenant) =>
              new Tenant(
                responseTenant.Id,
                responseTenant.Guid,
                responseTenant.Name,
              ),
          ),
        );
      });
    });
  }

  getTenantMediasLanguages(): Promise<[{ code: string; name: string }]> {
    return new Promise((resolve, reject) => {
      return this.httpService
        .get("tenant/GetTenantMediasLanguages")
        .then((response) => {
          let arr: any = [];
          response.forEach((lang) => {
            arr.push({ code: lang.Code, name: lang.Name });
          });
          resolve(arr);
        });
    });
  }
}
